import { AuthUserState } from './dto/response';

const CryptoJS = require('crypto-js');

export function encryptText(plainText: any) {
    if (!plainText) return ''
    let key = CryptoJS.enc.Utf8.parse('22fd580b89e9c1db824253b34d8476fec9ec29d4dce249b980d0e7d34dce5b0c');
    let iv = CryptoJS.enc.Utf8.parse('9c2b9115327c834e3fa023377ad3f999');
    let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
    let encPassword = CryptoJS.AES.encrypt(plainText, key, config);
    return encPassword.ciphertext.toString(CryptoJS.enc.Base64);
}

export const decryptText = (text: any) => {
    if (!text) return ''
    let key = CryptoJS.enc.Utf8.parse('22fd580b89e9c1db824253b34d8476fec9ec29d4dce249b980d0e7d34dce5b0c');
    let iv = CryptoJS.enc.Utf8.parse('9c2b9115327c834e3fa023377ad3f999');
    let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
    try {
        let encPassword = CryptoJS.AES.decrypt(text, key, config);
        return encPassword.toString(CryptoJS.enc.Utf8);
    } catch (err) {
        try {
            return JSON.parse(text)
        } catch (err1) {
            return text || ''
        }
    }
}

export const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const stableSort = <T>(array: readonly T[], comparator: (a: T, b: T) => number) => {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export const getComparator = <Key extends keyof any>(order: any, orderBy: Key,): (
    a: { [key in Key]: any },
    b: { [key in Key]: any },
) => number => {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export const descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export const isLoggedIn = (state: AuthUserState) => {
    const { Token, User, ExpiresAt } = state;
    const currentTime = Date.now();
    return !!User && !!Token && !!ExpiresAt && ExpiresAt > currentTime;
}


export const isAuthorizedPage = (moduleUrls: string[]) => {
    return true
}
